<template>
  <div class="qtfyfx-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="报价日期">
              <el-date-picker
                v-model="searchForm.time"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                :clearable="false"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="车间">
              <el-select v-model="searchForm.factory" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option v-for="item in factoryList" v-if="item.brand===0||group.dBrand===0||group.dBrand===item.brand" :key="item.factory_id" :label="item.simple_name" :value="item.factory_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="组织">
              <el-select v-model="searchForm.group" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option v-for="item in groupList" :key="item.groupid" :label="item.group_name" :value="item.groupid" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="getData">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row :gutter="20">
              <el-col :span="16">
                <el-table
                  :data="tableData"
                  v-loading="loading"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    prop="name"
                    label="品类"
                    align="center"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="priceTotal"
                    align="center"
                    label="金额">
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.priceTotal }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="金额占比">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="详情">
                    <template slot-scope="scope">
                      <el-button icon="el-icon-search"  size="mini" @click="view(scope.row)">查看详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="8">
                <GraphicsChart id="circle" :option="circleOption"></GraphicsChart>
              </el-col>
              <el-col :span="24" style="padding-top: 40px">
                <GraphicsChart id="height" :option="columnOption"/>
              </el-col>
            </el-row>
            <el-dialog
              :title="viewTitle"
              :visible.sync="viewVisible"
              width="80%"
              top="10vh"
              :destroy-on-close="true"
              :lock-scroll="true"
              :append-to-body="true">
              <div style="padding:10px 20px">
                <div style="height:40px">
                  <span style="color:#99a9bf">品类：</span>
                  <span style="font-weight: 500">{{ viewName }}</span>
                  <span style="color:#99a9bf;margin-left: 20px">报价日期：</span>
                  <span style="">{{ viewTime }}</span>
                  <span style="color:#99a9bf;margin-left: 20px">金额：</span>
                  <span style="color:#409EFF;font-weight: 500;">{{ viewAmount }}</span>
                  <el-button icon="el-icon-printer" style="float: right" size="small" :loading="excelLoading" @click="exportExcel">导出Excel</el-button>
                </div>
                <el-table
                  :data="viewData"
                  v-loading="viewLoading"
                  size="small"
                  style="width: 100%;border:1px solid #EBEEF5;"
                  height="442">
                  <el-table-column
                    prop="d_ordernum"
                    label="订单号"
                    align="center"
                    width="120"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="90"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF" v-if="scope.row.d_produnum!==null&&scope.row.d_produnum!==''&&scope.row.d_produnum!==undefined">{{scope.row.d_produnum}}</span>
                      <span style="font-weight: 500;color:#999999" v-if="scope.row.d_produnum===null||scope.row.d_produnum===''||scope.row.d_produnum===undefined">N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    align="center"
                    prop="d_allname"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    align="center"
                    width="110"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.d_type===0">正单</span>
                      <span v-if="scope.row.d_type===1">客改单</span>
                      <span v-if="scope.row.d_type===2">增补单</span>
                      <span v-if="scope.row.d_type===3">色板单</span>
                      <span v-if="scope.row.d_type===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产车间"
                    width="120"
                    align="center"
                    prop="d_abbname"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    label="预付款日期"
                    width="160"
                    align="center"
                    prop="d_subsist_time"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="d_address"
                    label="详细地址"
                    min-width="200"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    label="订单总金额"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.d_totalprice}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="类别金额"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.d_amount}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="d_name"
                    label="类别内容"
                    min-width="200"
                    show-overflow-tooltip>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="viewPage.total>0"
                  style="margin-top:10px;"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="viewPage.currentPage"
                  :page-sizes="[10, 20, 50]"
                  :page-size="viewPage.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="viewPage.total">
                </el-pagination>
              </div>
            </el-dialog>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getFactoryList,
  getGroupInfoByUser,
  getOrderOfferOtherAnalysis,
  getOfferOtherAnalysisOrderData,
  exportOfferOtherAnalysisOrderExcel
} from '@/api/erp'
import { getGroupReport } from '@/api/pub'
import GraphicsChart from '@/components/Charts/GraphicsChart'

export default {
  name: 'qtfyfx',
  components: { GraphicsChart },
  data() {
    return {
      tableData: [],
      loading: false,
      searchForm: {
        search: '',
        time: [],
        factory: '',
        group: null
      },
      groupList: [],
      factoryList: [],
      group: {
        dBrand: 1
      },
      columnData: [],
      columnOption: {
        title: false,
        credits: {
          enabled: false
        }
      },
      circleOption: {
        title: false,
        credits: {
          enabled: false
        }
      },
      viewTitle: '',
      viewVisible: false,
      viewAmount: 0,
      viewTime: '',
      viewName: '',
      excelLoading: false,
      viewData: [],
      viewLoading: false,
      viewPage: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
    }
  },
  computed: {
    user: getUser
  },
  created() {
    getGroupInfoByUser({ groupid: this.user.dGroupid }).then(response => {
      this.group = response.data
    })
    this.getFactoryList()
    this.getGroupList()
    const myDate = new Date()
    const year = myDate.getFullYear()
    let month = myDate.getMonth() + 1
    let day = myDate.getDate()
    month = month > 9 ? month + '' : '0' + month
    day = day > 9 ? day + '' : '0' + day
    this.searchForm.time.push(year + '-' + month + '-01')
    this.searchForm.time.push(year + '-' + month + '-' + day)
    this.getData()
  },
  methods: {
    getData() {
      let startTime = ''
      let endTime = ''
      if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
        startTime = this.searchForm.time[0]
        endTime = this.searchForm.time[1]
      }
      const data = {
        factory: this.searchForm.factory,
        group: this.searchForm.group,
        keyword: this.searchForm.search,
        startTime: startTime,
        endTime: endTime,
        userid: this.user.dUserid
      }
      this.loading = true
      this.columnData = []
      getOrderOfferOtherAnalysis(data).then(response => {
        this.tableData = response.data
        let circleData = []
        for (const item of response.data) {
          this.columnData.push({
            name: item.name,
            data: [item.priceTotal]
          })
          circleData.push({
            name: item.name,
            y: item.scaleTotal
          })
        }
        const circle = {
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
          },
          title: false,
          credits: {
            enabled: false
          },
          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.percentage:.1f} %'
              }
            }
          },
          series: [{
            name: '占比',
            colorByPoint: true,
            data: circleData
          }]
        }
        this.circleOption = circle
        const chart = {
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          chart: {
            type: 'column'
          },
          title: false,
          credits: {
            enabled: false
          },
          xAxis: {
            categories: [
              '品类'
            ],
            crosshair: true
          },
          yAxis: {
            min: 0,
            title: false
          },
          tooltip: {
            // head + 每个 point + footer 拼接成完整的 table
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
              '<td style="padding:0"><b>{point.y:.1f} 元</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            column: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.y}'
              }
            }
          },
          series: this.columnData
        }
        this.columnOption = chart
        this.loading = false
      })
    },
    getFactoryList() {
      getFactoryList().then(response => {
        this.factoryList = response.data
      })
    },
    getGroupList() {
      getGroupReport().then(response => {
        const arr = []
        for (const item of response.data) {
          if (item.nature === 0) {
            arr.push(item)
          }
        }
        this.groupList = arr
      })
    },
    view(row) {
      this.viewTitle = row.name + '报价详情'
      this.viewName = row.name
      if (this.searchForm.time.length === 2) {
        this.viewTime = this.searchForm.time[0] + ' 至 ' + this.searchForm.time[1]
      } else {
        this.viewTime = 'N/A'
      }
      this.viewAmount = row.priceTotal
      this.viewVisible = true
      this.viewPage.currentPage = 1
      this.viewPage.pageSize = 10
      this.getDetailData()
    },
    getDetailData() {
      this.viewLoading = true
      let startTime = ''
      let endTime = ''
      if (this.searchForm.time !== null && this.searchForm.time.length === 2){
        startTime = this.searchForm.time[0]
        endTime = this.searchForm.time[1]
      }
      let type = 99
      if (this.viewName === '其它') {
        type = 0
      } else if (this.viewName === '木架费') {
        type = 1
      } else if (this.viewName === '调色费') {
        type = 2
      } else if (this.viewName === '水性漆') {
        type = 3
      }
      const data = {
        factory: this.searchForm.factory,
        startTime: startTime,
        endTime: endTime,
        type: type,
        page: this.viewPage.currentPage,
        limit: this.viewPage.pageSize,
        group: this.searchForm.group,
        userid: this.user.dUserid
      }
      getOfferOtherAnalysisOrderData(data).then(response => {
        this.viewData = response.data
        this.viewPage.total = response.total
        this.viewLoading = false
      }).catch(() => {
        this.viewLoading = false
      })
    },
    exportExcel() {
      if (!this.excelLoading) {
        this.excelLoading = true
        let startTime = ''
        let endTime = ''
        if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
          startTime = this.searchForm.time[0]
          endTime = this.searchForm.time[1]
        }
        let type = 99
        if (this.viewName === '其它') {
          type = 0
        } else if (this.viewName === '木架费') {
          type = 1
        } else if (this.viewName === '调色费') {
          type = 2
        } else if (this.viewName === '水性漆') {
          type = 3
        }
        const data = {
          factory: this.searchForm.factory,
          startTime: startTime,
          endTime: endTime,
          type: type,
          group: this.searchForm.group,
          userid: this.user.dUserid,
          name: this.viewName
        }
        this.$message({
          message: '数据正在导出，请稍候'
        })
        exportOfferOtherAnalysisOrderExcel(data).then(response => {
          const _this = this
          let xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              let blob = this.response
              let a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
          this.excelLoading = false
        }).catch(() => {
          this.excelLoading = false
        })
      }
    },
    handleSizeChange(val) {
      this.viewPage.pageSize = val
      this.getDetailData()
    },
    handleCurrentChange(val) {
      this.viewPage.currentPage = val
      this.getDetailData()
    }
  }
}
</script>

<style scoped>

</style>
